<!-- SubscriptionModal.vue -->
<template>
    <div v-if="visible" class="subscription-overlay">
        <div class="subscription-dialog">
            <!-- Warning Icon -->
            <div class="subscription-icon">⚠️</div>

            <!-- Title -->
            <h2 class="subscription-title">
                Your subscription is about to expire.
            </h2>

            <!-- Subtitle -->
            <p class="subscription-subtitle">
                Please renew your subscription soon to avoid any service interruption.
            </p>

            <!-- Divider -->
            <div class="subscription-divider"></div>

            <!-- OK Button -->
            <!-- <button class="subscription-btn" @click="$emit('close')">
                OK
            </button> -->
        </div>
    </div>
</template>

<script>
import { getCookies, jwtDecode } from "@/utils"

export default {
    name: "SubscriptionModal",

    data() {
        return {
            visible: true,
            expired: false,
            timer: null,
        }
    },

    methods: {
        closeModal() {
            this.visible = false

            // reopen after 1 minute
            this.timer = setTimeout(() => {
                this.visible = true
            }, 60000)
        },
    },

    created() {
        const token = getCookies("token")
        if (!token) return

        const decoded = jwtDecode(token)

        // example condition
        if (decoded?.Email === "mrantiadmin@vectolabs.com") {
            this.expired = true
        }
    },

    beforeUnmount() {
        if (this.timer) clearTimeout(this.timer)
    },
}
</script>

<style scoped>
/* Overlay */
.subscription-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);

    display: flex;
    justify-content: center;
    align-items: center;

    z-index: 999999;
}

/* Modal Box */
.subscription-dialog {
    width: 480px;
    background: #fff;
    border-radius: 8px;
    padding: 32px 26px;
    text-align: center;

    box-shadow: 0 12px 35px rgba(0, 0, 0, 0.3);
}

/* Icon */
.subscription-icon {
    font-size: 52px;
    margin-bottom: 18px;
}

/* Title */
.subscription-title {
    font-size: 22px;
    font-weight: 700;
    color: #222;
    margin-bottom: 12px;
}

/* Subtitle */
.subscription-subtitle {
    font-size: 16px;
    color: #666;
    line-height: 1.5;
    margin-bottom: 24px;
}

/* Divider */
.subscription-divider {
    height: 1px;
    background: #ddd;
    margin-bottom: 20px;
}

/* Button */
.subscription-btn {
    width: 120px;
    padding: 12px;
    border: none;
    border-radius: 8px;

    background: #4d88db;
    color: #fff;
    font-size: 16px;
    font-weight: 600;

    cursor: pointer;
}

.subscription-btn:hover {
    background: #0d4fb3;
}
</style>
